module.exports = __webpack_public_path__ + "img/Base_SX.6f10d5e5.png";